import { Icon } from '@festina-life/ui/structure'
import cx from 'classnames'

import { BlockIndicator } from '../blockIndicator/BlockIndicator'
import { ConfigurationItemIcon } from '../configurationItemIcon/ConfigurationItemIcon'
import { LayerIndicator } from '../layerIndicator/LayerIndicator'
import type { ConfigurationItemSearchResult } from './types'

type Props = {
  item: ConfigurationItemSearchResult
}

export const ConfigurationOperationSearchResult = ({ item }: Props) => (
  <div>
    <div className="flex justify-between p-1">
      <div className="flex w-full items-center gap-x-1">
        <ConfigurationItemIcon type={item.value.operationType} />
        <div
          className={cx('overflow-hidden text-ellipsis', {
            'text-draft-600 dark:text-draft-400': item.value.isDraft,
          })}
        >
          {item.value.id}
        </div>
        {!!item.value.type && (
          <div className="overflow-hidden text-ellipsis rounded-md px-1 text-sm italic opacity-50">
            {item.value.type}
          </div>
        )}
        <BlockIndicator
          block={item.value.block}
          shouldShowIcon={false}
          isSecondaryBackground
        />
        <LayerIndicator layer={item.value.layer} isSecondaryBackground />
      </div>
      <div className="flex flex-row items-center gap-x-1 text-right opacity-50">
        <Icon name="Folder" />
        <div>{item.value.packageName}</div>
      </div>
    </div>
  </div>
)
